__turbopack_context__.v({
  "with-placeholder": "WithPlaceholder-module-scss-module__j9Nsea__with-placeholder",
});
